module.exports = __webpack_public_path__ + "img/logo_happily.4585b5c6.webp";